const statuses = {
    ASSIGNED: {label: "CourierDeliveryAssigned", color: "warning"},
    UNASSIGNED: {label: "CourierUnassigned", color: "default"},
    REASSIGNED: {label: "CourierReassigned", color: "warning"},
    ACCEPTED: {label: "CourierDeliveryAccepted", color: "info"},
    PICKED_UP: {label: "CourierDeliveryPickedUp", color: "primary"},
    IN_DELIVERY: {label: "CourierDeliveryInDelivery", color: "primary"},
    DELIVERED: {label: "CourierDeliveryDelivered", color: "success"},
};

export const deliveryProgress = status => statuses[status] || {label: "CourierDeliveryUnknown", color: "default"};

const approvalTimelineLabels = {
    OrderProposalCONFIRMED: "OrderProposalCONFIRMEDStatus",
    OrderProposalDECLINED: "OrderProposalDECLINEDStatus",
    OrderProposalEXPIRED: "OrderProposalEXPIREDStatus",
    OrderApprovalAutomaticallyConfirmed: "OrderApprovalAutomaticallyConfirmedStatus",
    OrderApprovalConfirmed: "OrderApprovalConfirmedStatus",
    OrderApprovalRejected: "OrderApprovalRejectedStatus",
    OrderApprovalAwaitingConfirmation: "OrderApprovalAwaitingConfirmationStatus",
};

export const isDeliveryTimelineEvent = event => ["CourierAssigned", "CourierUnassigned", "CourierReassigned", "CourierDeliveryProgress"].includes(event.description);

// Assignment audit events carry commercial order status, so derive their delivery label from the event type.
export const deliveryTimelineStatus = event => event.description === "CourierAssigned" ? "ASSIGNED"
    : event.description === "CourierUnassigned" ? "UNASSIGNED"
        : event.description === "CourierReassigned" ? "REASSIGNED" : event.status;

export const timelineStatusLabel = event => approvalTimelineLabels[event.description] || (isDeliveryTimelineEvent(event)
    ? deliveryProgress(deliveryTimelineStatus(event)).label : event.status);

export const timelineDescriptionLabel = event => event.description === "CourierDeliveryProgress"
    ? (statuses[event.status] ? `${statuses[event.status].label}Event` : "CourierDeliveryProgressEvent") : event.description;
